module.exports = __webpack_public_path__ + "static/img/naves-industriales-mexico2.ae56153.jpg";